/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandsConfiguration } from './brandsConfiguration';


export interface ClientsConfiguration { 
    name: string;
    key: string;
    client: string;
    allBrands?: boolean;
    brands?: Array<BrandsConfiguration>;
}

